<div class="basicrow mbott">
  <div class="autowcont">
    <div class="basicrow msidespad">
      <div class="b-title">
        <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
          <div class="tabcell">
            Consumo
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow msidespad roboto-r m-bott f-reg f-black" *ngIf="this.typeAccount=='Movil'">
      <div class="device-i rpad roboto-b" *ngIf="this.usage2[0].subscriber.length > 0">
        <div class="basicrow f-bmed roboto-b">
          Data
        </div>
        <div class="basicrow m-top-ii" *ngFor="let usage of this.usage2[0].subscriber; let j = index">
          <div class="basicrow f-mini f-black roboto-r text1">
            <span class="roboto-b">Consumo Local:</span><br>
            {{usage.DPlanName}}
          </div>
          <div class="borde1">
            <app-graphic [indexI]="0" [indexJ]="j" [index]="this.index"></app-graphic>
          </div>
          <div class="basicrow f-mini f-black roboto-r text-right text1">
            {{usage.iDLocalText}} DE {{usage.DLocalTop}} USADOS
          </div>
        </div>
      </div>
      <div class="device-i rpad roboto-b alturaNoData" *ngIf="this.usage2[0].subscriber.length == 0">
        <div class="basicrow f-bmed roboto-b">
          Data
        </div>
        <div class="basicrow noDataInfo m-top-ii">
          Actualmente no existe un consumo de datos.
        </div>
      </div>
      <div class="device-i middle">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Consumo de Voz
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Minutos Usados
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.minutesUsageField}} Minutos
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Larga Distancia
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.lDUsageField}} Minutos
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Roaming Voz
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.lDIUsageField}} Minutos
            </div>
          </div>
        </div>
      </div>
      <div class="device-i last roboto-r">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Consumo de Mensajer&iacute;a (SMS/MMS)
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              SMS
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.sMSUSageField}}
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              SMS Premium
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.sMSPremiunUsageField}}
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              MMS
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.mMSUsageField}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow msidespad roboto-r m-bott f-reg f-black" *ngIf="this.typeAccount=='Fijo'">
      <div class="device-i middle only-call">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Consumo de Voz
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Minutos Usados
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.minutesUsageField}} Minutos
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Larga Distancia
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.lDUsageField}} Minutos
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Roaming Voz
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.lDIUsageField}} Minutos
            </div>
          </div>
        </div>
      </div>
      <div class="device-i last roboto-r only-call" *ngIf="this.typeAccount=='Movil'">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Consumo de Mensajer&iacute;a (SMS/MMS)
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              SMS
            </div>          
            <div class="autorow roboto-b pull-right">
              {{this.sMSUSageField}}
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              SMS Premium
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.sMSPremiunUsageField}}
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              MMS
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.mMSUsageField}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>